import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { AllPagesState, ClearPagingState, PagingParams, QueryFiltersParams } from 'mbs-ui-shared@models/Paging';
import { BackupHistory } from 'mbs-ui-shared@models/backupHistory';

// adapter
export function selectBackupHistoryId(entity: BackupHistory): string {
  return entity?.id;
}

export const backupHistoryAdapter: EntityAdapter<BackupHistory> = createEntityAdapter<BackupHistory>({ selectId: selectBackupHistoryId });

// state models
export type BackupHistoryState = EntityState<BackupHistory> & {
  paging: ClearPagingState &
    PagingParams & {
      pages: AllPagesState;
      filters: QueryFiltersParams;
      obsolescenceMark: number;
    };
  showLatestPlanResult: number;
  totalComputers: number;
};

export const initialBackupHistoryState: BackupHistoryState = backupHistoryAdapter.getInitialState({
  paging: {
    loading: false,
    loaded: false,
    total: 0,
    currentPageNumber: 1,
    perPage: null,
    filters: {},
    pages: {},
    obsolescenceMark: null
  },
  showLatestPlanResult: 0,
  totalComputers: 0
});
